import { render } from "./Newinvoice.vue?vue&type=template&id=4ebab7e8&scoped=true"
import script from "./Newinvoice.vue?vue&type=script&lang=js"
export * from "./Newinvoice.vue?vue&type=script&lang=js"

import "./Newinvoice.vue?vue&type=style&index=0&id=4ebab7e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebab7e8"]])

export default __exports__